import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url() {
    return buildApiUrl(ADMIN_ENDPOINTS.KYC_LIST, {
      queryParams: {
        type: 'rider',
        limit: 100
      }
    })
  },

  parse(raw = {}) {
    // MonRapidoo API retourne statusCode/message au lieu de success
    if (!raw?.statusCode || raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to fetch KYC data',
        data: null,
      }
    }

    const kycDocuments = raw.data?.data || [] // Tableau dans data.data

    const formatted = kycDocuments.map(el => {
      const kycData = el.data || {}
      const metadata = el.metadata || {}
      const verification = el.verification || {}

      return {
        id: el.id,
        userId: el.userId,
        userType: el.userType || 'rider',
        status: el.status || 'draft',
        uploadedAt: el.submittedAt || el.createdAt,
        createdAt: el.createdAt,
        updatedAt: el.updatedAt,

        // Rider-specific fields mapping from the new schema
        userName: kycData.personalInfo?.firstName && kycData.personalInfo?.lastName
          ? `${kycData.personalInfo.firstName} ${kycData.personalInfo.lastName}`.trim()
          : kycData.personalInfo?.fullName || 'Rider',
        fullName: kycData.personalInfo?.fullName || (kycData.personalInfo?.firstName ? `${kycData.personalInfo.firstName} ${kycData.personalInfo.lastName || ''}` : null),
        phoneNumber: kycData.personalInfo?.phone || kycData.personalInfo?.phoneNumber,
        birthDate: kycData.personalInfo?.birthDate || kycData.personalInfo?.dateOfBirth ? new Date(kycData.personalInfo.birthDate || kycData.personalInfo.dateOfBirth).toLocaleDateString() : '-',
        gender: kycData.personalInfo?.gender,
        nationality: kycData.personalInfo?.nationality,
        address: kycData.personalInfo?.address,
        city: kycData.personalInfo?.city,
        country: kycData.personalInfo?.country || kycData.personalInfo?.countryCode,

        // ID document
        idType: kycData.identityDocument?.type,
        idNumber: kycData.identityDocument?.number,
        idExpiryDate: kycData.identityDocument?.expirationDate,
        idFrontUrl: kycData.identityDocument?.frontPhotoUrl,
        idBackUrl: kycData.identityDocument?.backPhotoUrl,

        // Vehicle info
        vehicleType: kycData.vehicleDocument?.type,
        licenseNumber: kycData.vehicleDocument?.number || kycData.vehicleDocument?.licenseNumber,
        vehiclePhotoUrl: kycData.vehicleDocument?.photoUrl,
        vinNumber: kycData.vehicleDocument?.vinNumber,

        // Selfie
        selfieUrl: kycData.selfieUrl,

        // Metadata and verification
        requiredSteps: metadata.requiredSteps || [],
        completedSteps: metadata.completedSteps || [],
        nextAction: metadata.nextAction || '',
        rejectionReason: verification.reason || '',
        rejectionNotes: verification.notes || '',
        reviewBy: verification.reviewedBy || '',
        reviewedAt: verification.reviewedAt || '',

        // Raw KYC data for details view
        kycData: kycData,
      }
    })

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: formatted.length,
        result: formatted,
      },
    }
  },
}
